import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { TEAM } from '../data';
import { useReveal } from '../hooks/useReveal';
import ParallaxHero from '../components/ParallaxHero';


export default function Team() {
  useReveal();
  return (
    <>
      <Helmet>
        <title>Our Team | ITClave — Founders of Bihar's Best IT Company</title>
        <meta name="description" content="Meet Ravi Shankar (Founder & CEO) and Somank Kumar (Head of Digital Marketing) — the driving force behind ITClave, Patna's #1 IT company."/>
      </Helmet>

      {/* ── Page Hero ── */}
      <ParallaxHero
        page="team"
        eyebrow="Meet the Team"
        title="Our Team"
        subtitle="The passionate builders, marketers, and problem-solvers behind ITClave's success."
        cta={false}
      />

      {/* ── Team Cards ── */}
      <section style={{ background:'var(--bg3)', padding:'90px 0' }}>
        <div className="container">
          {/* 2-column centred grid */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(2, 1fr)',
            gap: 48,
            maxWidth: 860,
            margin: '0 auto',
          }}>
            {TEAM.map((m, i) => (
              <div
                key={i}
                className="reveal"
                style={{
                  background: '#fff',
                  border: '1.5px solid var(--border2)',
                  borderRadius: 28,
                  overflow: 'hidden',
                  transition: 'all .35s',
                  transitionDelay: `${i * .15}s`,
                  boxShadow: 'var(--sh)',
                }}
                onMouseOver={e => {
                  e.currentTarget.style.transform = 'translateY(-10px)';
                  e.currentTarget.style.boxShadow = 'var(--sh-xl)';
                  e.currentTarget.style.borderColor = 'rgba(123,82,171,.18)';
                }}
                onMouseOut={e => {
                  e.currentTarget.style.transform = '';
                  e.currentTarget.style.boxShadow = 'var(--sh)';
                  e.currentTarget.style.borderColor = 'var(--border2)';
                }}
              >
                {/* ── Photo with gradient hover overlay ── */}
                <div style={{ position:'relative', height:300, overflow:'hidden' }}>
                  <img
                    src={m.img}
                    alt={`${m.name} — ${m.role} at ITClave Patna`}
                    loading="lazy"
                    style={{ width:'100%', height:'100%', objectFit:'cover', objectPosition:'top center', transition:'transform .6s' }}
                    onMouseOver={e => e.target.style.transform = 'scale(1.06)'}
                    onMouseOut={e  => e.target.style.transform = 'scale(1)'}
                  />
                  {/* Social hover overlay */}
                  <div
                    style={{ position:'absolute', inset:0, background:'linear-gradient(135deg,rgba(232,49,91,.85),rgba(123,82,171,.85),rgba(75,184,232,.85))', opacity:0, display:'flex', alignItems:'flex-end', justifyContent:'center', paddingBottom:24, transition:'opacity .35s', gap:12 }}
                    onMouseOver={e => e.currentTarget.style.opacity = '1'}
                    onMouseOut={e  => e.currentTarget.style.opacity = '0'}
                  >
                    <a href={m.li} target="_blank" rel="noopener noreferrer" aria-label={`${m.name} LinkedIn`}
                      style={{ width:42, height:42, borderRadius:'50%', background:'rgba(255,255,255,.2)', border:'1.5px solid rgba(255,255,255,.5)', display:'flex', alignItems:'center', justifyContent:'center', transition:'all .3s' }}
                      onMouseOver={e => { e.currentTarget.style.background='#0A66C2'; e.currentTarget.style.borderColor='#0A66C2'; }}
                      onMouseOut={e  => { e.currentTarget.style.background='rgba(255,255,255,.2)'; e.currentTarget.style.borderColor='rgba(255,255,255,.5)'; }}
                    >
                      <svg width="17" height="17" viewBox="0 0 24 24" fill="white">
                        <path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/>
                        <circle cx="4" cy="4" r="2"/>
                      </svg>
                    </a>
                    <a href={m.tw} target="_blank" rel="noopener noreferrer" aria-label={`${m.name} Twitter`}
                      style={{ width:42, height:42, borderRadius:'50%', background:'rgba(255,255,255,.2)', border:'1.5px solid rgba(255,255,255,.5)', display:'flex', alignItems:'center', justifyContent:'center', transition:'all .3s' }}
                      onMouseOver={e => { e.currentTarget.style.background='#000'; e.currentTarget.style.borderColor='#000'; }}
                      onMouseOut={e  => { e.currentTarget.style.background='rgba(255,255,255,.2)'; e.currentTarget.style.borderColor='rgba(255,255,255,.5)'; }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                        <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                      </svg>
                    </a>
                    <a href={`https://wa.me/917808707393`} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"
                      style={{ width:42, height:42, borderRadius:'50%', background:'rgba(255,255,255,.2)', border:'1.5px solid rgba(255,255,255,.5)', display:'flex', alignItems:'center', justifyContent:'center', transition:'all .3s' }}
                      onMouseOver={e => { e.currentTarget.style.background='#25D366'; e.currentTarget.style.borderColor='#25D366'; }}
                      onMouseOut={e  => { e.currentTarget.style.background='rgba(255,255,255,.2)'; e.currentTarget.style.borderColor='rgba(255,255,255,.5)'; }}
                    >
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="white">
                        <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
                      </svg>
                    </a>
                  </div>

                  {/* Role badge on photo */}
                  <div style={{
                    position:'absolute', top:16, left:16,
                    background:'rgba(255,255,255,.92)',
                    backdropFilter:'blur(10px)',
                    border:'1px solid rgba(255,255,255,.7)',
                    borderRadius:100,
                    padding:'5px 14px',
                    fontSize:'.72rem', fontWeight:800,
                    background:'linear-gradient(135deg,#E8315B,#7B52AB,#4BB8E8)',
                    WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent', backgroundClip:'text',
                    background:'rgba(255,255,255,.9)',
                    color:'var(--purple)',
                  }}>
                    {i === 0 ? '👑 Founder & CEO' : '📈 Marketing Head'}
                  </div>
                </div>

                {/* ── Info ── */}
                <div style={{ padding:'26px 24px 28px', textAlign:'center' }}>
                  {/* Avatar initials */}
                  <div style={{
                    width:56, height:56, borderRadius:'50%',
                    background:'linear-gradient(135deg,#E8315B,#7B52AB,#4BB8E8)',
                    color:'#fff', fontWeight:900, fontSize:'1.1rem',
                    fontFamily:"'Outfit',sans-serif",
                    display:'flex', alignItems:'center', justifyContent:'center',
                    margin:'-42px auto 14px',
                    border:'3px solid #fff',
                    boxShadow:'0 4px 18px rgba(123,82,171,.25)',
                    position:'relative', zIndex:1,
                  }}>
                    {m.av}
                  </div>

                  {/* Name */}
                  <h2 style={{
                    fontFamily:"'Outfit',sans-serif", fontWeight:900,
                    fontSize:'1.25rem', color:'var(--text)',
                    letterSpacing:'-.03em', marginBottom:4,
                  }}>
                    {m.name}
                  </h2>

                  {/* Role */}
                  <div style={{
                    fontSize:'.82rem', fontWeight:700,
                    background:'linear-gradient(90deg,#E8315B,#7B52AB,#4BB8E8)',
                    WebkitBackgroundClip:'text', WebkitTextFillColor:'transparent',
                    backgroundClip:'text', marginBottom:16,
                    letterSpacing:'.02em',
                  }}>
                    {m.role}
                  </div>

                  {/* Divider */}
                  <div style={{ width:40, height:2, background:'var(--grad)', borderRadius:2, margin:'0 auto 16px' }}/>

                  {/* Bio */}
                  <p style={{ fontSize:'.88rem', color:'var(--text2)', lineHeight:1.72 }}>
                    {m.bio}
                  </p>

                  {/* ITClave label */}
                  <div style={{
                    marginTop:20,
                    display:'inline-flex', alignItems:'center', gap:6,
                    background:'var(--grad-soft)',
                    border:'1px solid var(--border)',
                    borderRadius:100, padding:'5px 14px',
                    fontSize:'.74rem', fontWeight:700, color:'var(--purple)',
                  }}>
                    🏢 ITClave, Patna
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ── Join CTA ── */}
      <section style={{ background:'#fff', padding:'64px 0' }}>
        <div className="container" style={{ textAlign:'center' }}>
          <h2 style={{ fontFamily:"'Outfit',sans-serif", fontSize:'clamp(1.7rem,3vw,2.2rem)', fontWeight:900, color:'var(--text)', letterSpacing:'-.04em', marginBottom:14 }}>
            Want to Join Our <span className="gt">Growing Team?</span>
          </h2>
          <p style={{ color:'var(--text2)', fontSize:'.97rem', marginBottom:28, maxWidth:480, margin:'0 auto 28px' }}>
            We're always looking for talented people passionate about technology and Bihar's digital future.
          </p>
          <div style={{ display:'flex', gap:14, justifyContent:'center', flexWrap:'wrap' }}>
            <Link to="/careers" className="btn-main">🚀 View Open Positions</Link>
            <Link to="/careers#internship" className="btn-out">🎓 Apply for Internship</Link>
          </div>
        </div>
      </section>

      <style>{`
        @media(max-width:640px) {
          /* Stack to single column on mobile */
          .team-2col { grid-template-columns: 1fr !important; max-width: 420px !important; }
        }
      `}</style>
    </>
  );
}
